import React from 'react';
import useIllustrationColor from '@cvent/blocks/hooks/useIllustrationColor';

type AlertLightDarkProps = {
  color: string;
};

type AlertProps = {
  size?: number;
};

function LightBackgroundAlert({ color }: AlertLightDarkProps) {
  return (
    <>
      <g clipPath="url(#clip0_1775_31)">
        <path
          opacity="0.1"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M70.8655 59.5546C110.315 25.6088 248.376 25.6088 224.045 116.494C210.647 166.532 170.19 160.459 139.657 192.725C109.124 224.994 21.3071 220.282 23.1634 151.186C26.0363 94.3889 50.7196 76.8899 70.8655 59.5546Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M191.427 193.908C243.14 186.131 161.052 94.4729 148.34 73.6584C142.833 64.6417 131.004 62.4813 122.075 69.45C97.3105 95.7979 82.0855 130.952 66.8001 163.648C51.0855 195.708 83.3209 192.185 104.306 192.588C133.338 193.45 162.383 193.89 191.427 193.908Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M191.427 193.908C243.14 186.131 161.052 94.4729 148.34 73.6584C142.834 64.6417 131.005 62.4813 122.075 69.45C97.3108 95.7979 82.0858 130.952 66.8004 163.648C51.0858 195.708 83.3212 192.185 104.307 192.588C133.338 193.45 162.384 193.89 191.427 193.908Z"
          fill="black"
          fillOpacity="0.3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M179.377 187.5C229.65 179.939 149.85 90.8371 137.494 70.6038C132.137 61.8371 120.639 59.7371 111.958 66.5121C87.8852 92.1246 73.0831 126.3 58.2248 158.083C42.9477 189.252 74.2852 185.825 94.6852 186.216C122.908 187.056 151.141 187.483 179.377 187.5Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M115.48 98.1929C118.311 95.1071 122.67 94.038 126.553 94.5858L127.057 94.6664L127.6 94.775C138.316 97.1403 140.468 111.044 136.309 120.406L134.675 123.928L133.899 125.642L132.612 128.534C132.049 129.81 131.48 131.115 130.913 132.427L129.759 135.113L128.579 137.895C127.452 140.583 123.584 140.4 122.715 137.618C122.046 135.478 121.383 133.627 120.646 131.805L120.17 130.656L119.413 128.922L117.276 124.222L116.52 122.499C115.995 121.275 115.502 120.069 115.007 118.784C111.347 109.294 111.614 102.407 115.48 98.1929Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M128.055 151.323L128.126 151.417L128.364 151.426C134.349 151.836 137.007 159.858 132.11 163.797L131.819 164.02C127.099 167.459 121.845 166.298 119.754 161.824C117.807 157.656 119.616 152.625 124.4 150.492C125.698 149.914 127.18 150.292 128.055 151.323Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1775_31">
          <rect width="250" height="250" fill="white" />
        </clipPath>
      </defs>
    </>
  );
}

function DarkBackgroundAlert({ color }: AlertLightDarkProps) {
  return (
    <>
      <g clipPath="url(#clip0_1775_30)">
        <path
          opacity="0.1"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M70.8653 59.5546C110.315 25.6088 248.376 25.6088 224.045 116.494C210.647 166.532 170.19 160.459 139.657 192.725C109.124 224.994 21.307 220.282 23.1633 151.186C26.0362 94.3889 50.7195 76.8899 70.8653 59.5546Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M191.427 193.908C243.14 186.131 161.052 94.4729 148.34 73.6584C142.833 64.6417 131.004 62.4813 122.075 69.45C97.3105 95.7979 82.0855 130.952 66.8001 163.648C51.0855 195.708 83.3209 192.185 104.306 192.588C133.338 193.45 162.383 193.89 191.427 193.908Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M191.427 193.908C243.14 186.131 161.052 94.4729 148.34 73.6584C142.834 64.6417 131.005 62.4813 122.075 69.45C97.3108 95.7979 82.0858 130.952 66.8004 163.648C51.0858 195.708 83.3212 192.185 104.307 192.588C133.338 193.45 162.384 193.89 191.427 193.908Z"
          fill="black"
          fillOpacity="0.3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M179.377 187.5C229.65 179.939 149.85 90.8371 137.494 70.6038C132.137 61.8371 120.639 59.7371 111.958 66.5121C87.8852 92.1246 73.0831 126.3 58.2248 158.083C42.9477 189.252 74.2852 185.825 94.6852 186.216C122.908 187.056 151.141 187.483 179.377 187.5Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M179.377 187.5C229.65 179.939 149.85 90.8371 137.494 70.6038C132.137 61.8371 120.639 59.7371 111.958 66.5121C87.8852 92.1246 73.0831 126.3 58.2248 158.083C42.9477 189.252 74.2852 185.825 94.6852 186.216C122.908 187.056 151.141 187.483 179.377 187.5Z"
          fill="white"
          fillOpacity="0.6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M115.48 98.1929C118.311 95.1071 122.67 94.038 126.553 94.5858L127.057 94.6664L127.6 94.775C138.316 97.1403 140.468 111.044 136.309 120.406L134.675 123.928L133.899 125.642L132.612 128.534C132.049 129.81 131.48 131.115 130.913 132.427L129.759 135.113L128.579 137.895C127.452 140.583 123.584 140.4 122.715 137.618C122.046 135.478 121.383 133.627 120.646 131.805L120.17 130.656L119.413 128.922L117.276 124.222L116.52 122.499C115.995 121.275 115.502 120.069 115.007 118.784C111.347 109.294 111.614 102.407 115.48 98.1929Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M128.055 151.323L128.126 151.417L128.364 151.426C134.349 151.836 137.007 159.858 132.11 163.797L131.819 164.02C127.099 167.459 121.845 166.298 119.754 161.824C117.807 157.656 119.616 152.625 124.4 150.492C125.698 149.914 127.18 150.292 128.055 151.323Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1775_30">
          <rect width="250" height="250" fill="white" />
        </clipPath>
      </defs>
    </>
  );
}

export default function Alert({ size = 250 }: AlertProps) {
  const { color, isLight } = useIllustrationColor();

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 250 250"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-hidden="true"
    >
      {isLight ? <LightBackgroundAlert color={color} /> : <DarkBackgroundAlert color={color} />}
    </svg>
  );
}
